import {
  ACTION_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import { on } from '@ember/modifier';
import SecondaryButton from '../secondary.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Trigger button for filter menu',
  extends: [
    pick(ACTION_ARGS, ['onClick']),
    pick(COMPONENT_STATE_ARGS, ['autofocus', 'disabled', 'open']),
    pick(CONTAINER_ARGS, ['fitContent']),
    pick(CONTENT_ARGS, ['text']),
  ],
  name: 'Filter Trigger',
});

export default class SpdsActionButtonFilterTrigger extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-action-button-filter-trigger';
  classesToMapToArgs = ['open'];

  <template>
    <SecondaryButton
      @autofocus={{@autofocus}}
      @disabled={{@disabled}}
      @fitContent={{@fitContent}}
      @text={{@text}}
      class={{this.classes}}
      data-test-spds-action-button-filter-trigger
      ...attributes
      {{this.validateArguments}}
      {{this.setupComponent}}
      {{on "click" @onClick}}
    >
      {{yield}}
    </SecondaryButton>
  </template>
}

export const ACTION_BUTTON_FILTER_TRIGGER_METADATA = SpdsActionButtonFilterTrigger.metadata;
